// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".encuestas .custom-select.is-valid,.encuestas .custom-select option:not(:first-child){text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
